import createDeferredScreen from "../createDeferredScreen";

export const TimeOffRequest = createDeferredScreen(() => import('./team/timeOffRequest'));
export const CreateTaskManger = createDeferredScreen(() => import('./team/createNewtask'));
export const TaskManagement = createDeferredScreen(() => import('./team/taskManagement'));
export const AllTasksList = createDeferredScreen(() => import('./team/taskList'));
export const TeamTimeSheet = createDeferredScreen(() => import('./team/teamTimeSheet'));
export const Certificate = createDeferredScreen(() => import('./team/Certificate/index.js'));
export const ViewCertificateTemplates = createDeferredScreen(() => import('./team/viewCertificateTemplates'));
export const EmployeCertificateTemplates = createDeferredScreen(() => import('./team/employeCertificateTemplates'));
export const AssignCertificateTemplate = createDeferredScreen(() => import('./team/assignCertificateTemplate'));
export const ManageTeamList = createDeferredScreen(() => import('./team/myTeam'));
export const CheckInOutLogs = createDeferredScreen(() => import('./team/checkInOutLogs'));
export const ManagePharmacySettings = createDeferredScreen(() => import('../settings/pharmacySettings'));
export const AssignDepartments = createDeferredScreen(() => import('./team/assignDepartments'));
export const TeamSchedule = createDeferredScreen(() => import('./team/teamSchedule'));
